export const PHONE = "+49 177 4563027";
export const PHONE_TEL = "+491774563027";
export const WHATSAPP = "491774563027";
export const EMAIL = "nzclean.de@gmail.com";

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/b66166829193f4b1c0212099f208d7c30f7f3155670d4867b84a5396e92a4661.png";

export const WHY_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/6fb973c62fa3c7fe5763db8c60e210fb690f2e7b3d6bf7862049c15625842649.png";

export const BANNER_IMAGE =
  "https://images.unsplash.com/photo-1580842402762-6f5868c17412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxqYW5pdG9yJTIwY2xlYW5pbmclMjBjYXJ0JTIwdHJvbGxleSUyMHN1cHBsaWVzfGVufDB8fHx8MTc4Mzk2MzAxOHww&ixlib=rb-4.1.0&q=85";
